
  <span class="dialog-close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </span>
  <h2 mat-dialog-title>E-Mail für Rechnungsempfang bearbeiten</h2>
  <mat-dialog-content class="flex flex-col">
    <form [formGroup]="emailForm" class="p-3">
      <mat-form-field class="white email">
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="email">
        <mat-error *ngIf="emailForm.get('email').hasError('pattern')">
          Bitte geben Sie eine gültige E-Mail-Adresse ein.
        </mat-error>
        <mat-error *ngIf="emailForm.get('email').hasError('required')">
          E-Mail ist erforderlich.
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button (click)="onSave()" color="primary" [disabled]="!emailForm.valid">Speichern</button>
    <button mat-flat-button matDialogClose="no" color="primary">Abbrechen</button>
  </mat-dialog-actions>

